import axios from 'axios';
import { CHECK_IN_STATUS_HISTORY_URL } from 'Constants';

export function getFilteredTrackingHistoryForBooking(bookingId: string) {
	return axios.get(`${CHECK_IN_STATUS_HISTORY_URL}/get-check-in-history?bookingId=${bookingId}`).then(x => x.data);
}

export interface BookingCheckInStatusHistoryDto {
	statusId: string;
	order: number;
	completed: boolean;
	statusLabel: string;
	timestamp?: string;
	location?: string;
	staffName?: string;
}
